import { useQuery } from '@tanstack/react-query';

interface PeakLoad {
  value: number;
  startTime: string;
  endTime: string;
}

export function usePeakLoad() {
  return useQuery({
    queryKey: ['energy', 'peak'],
    queryFn: async (): Promise<PeakLoad> => {
      const res = await fetch('/api/energy/peak');
      if (!res.ok) throw new Error('Failed to fetch peak load');
      return res.json();
    },
    staleTime: 60000,
  });
}
